module.exports = __webpack_public_path__ + "img/中雨.938c131c.png";